import React from 'react';
import { ExternalE2EEKeyProvider } from 'livekit-client';
import { decodePassphrase } from './client-utils';

export function useSetupE2EE() {
  const [e2eePassphrase, setE2eePassphrase] = React.useState<string | undefined>(undefined);
  const [worker, setWorker] = React.useState<Worker | undefined>(undefined);

  React.useEffect(() => {
    // Garantir que só execute no cliente
    if (typeof window === 'undefined') return;

    const passphrase = decodePassphrase(location.hash.substring(1));
    setE2eePassphrase(passphrase);

    if (passphrase) {
      const newWorker = new Worker(new URL('livekit-client/e2ee-worker', import.meta.url));
      setWorker(newWorker);
    }
  }, []);

  return { worker, e2eePassphrase };
}
